export default __webpack_public_path__ + "media/images/hero-260f80b9d2e44b9103bfe3feb14eb4aa.jpg";